/**
=========================================================
* Material Dashboard 2 React - v2.1.0
=========================================================

* Product Page: https://www.creative-tim.com/product/material-dashboard-react
* Copyright 2022 Creative Tim (https://www.creative-tim.com)

Coded by www.creative-tim.com

 =========================================================

* The above copyright notice and this permission notice shall be included in all copies or substantial portions of the Software.
*/

// prop-types is a library for typechecking of props

// @mui material components
import Icon from "@mui/material/Icon";

// Material Dashboard 2 React components
import MDBox from "components/MDBox";
import MDTypography from "components/MDTypography";
import { useDispatch } from "react-redux";
import { authActions } from "../../../store/auth/auth-slice";
import { notificationActions } from "../../../store/notification/notification-slice";
import {useMeQuery} from "../../../store/api/auth";
import {  signOut } from "firebase/auth";
import {auth} from "../../../firebase";
import {useNavigate} from "react-router";

function NavbarLogout({ icon, name, light }) {
  const dispatch = useDispatch();
  const navigate = useNavigate();

  const logoutHandler = () => {
    signOut(auth).then(() => {
      // Sign-out successful.
      localStorage.removeItem("token");
      dispatch(authActions.logout());
      dispatch(
          notificationActions.showMessage({ message: "Logged out successfully", variant: "success" })
      );
      // navigate("/");
      window.location.reload(false);

    }).catch((error) => {
      dispatch(
          notificationActions.showMessage({ message: "An error occured", variant: "error" })
      );
    });
    // window.location.reload(false);
  };

  return (
    <MDBox
      onClick={logoutHandler}
      mx={1}
      p={1}
      display="flex"
      alignItems="center"
      sx={{ cursor: "pointer", userSelect: "none" }}
    >
      <Icon
        sx={{
          color: ({ palette: { white, secondary } }) => (light ? white.main : secondary.main),
          verticalAlign: "middle",
        }}
      >
        {icon}
      </Icon>
      <MDTypography
        variant="button"
        fontWeight="regular"
        color={light ? "white" : "dark"}
        textTransform="capitalize"
        sx={{ width: "100%", lineHeight: 0 }}
      >
        &nbsp;{name}
      </MDTypography>
    </MDBox>
  );
}

export default NavbarLogout;
